import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';

export const getDomainUsersGridInitialState = (): GridInitialStatePro => {
  return {
    sorting: {
      sortModel: [{ field: 'userCount', sort: 'desc' }],
    },
  };
};
